import {
  ContentBlock,
  Heading,
  Stack,
  Columns,
  Column,
  Box,
} from 'braid-design-system';
import React, { type ReactChild } from 'react';

import * as styles from './ProductPromos.css';

interface Props {
  title: string;
  children: ReactChild;
  icon: string;
  reverse?: boolean;
  tone?: 'purple' | 'yellow';
}

const ProductPromos = ({ title, children, icon, reverse, tone }: Props) => {
  const starClass = {
    [styles.star]: tone,
    [styles.yellowStar]: tone === 'yellow',
    [styles.purpleStar]: tone === 'purple',
  };

  return (
    <Box
      style={{
        backgroundColor: tone && (tone === 'purple' ? '#f6f2ff' : '#fffbea'),
      }}
    >
      <ContentBlock>
        <Box
          position="relative"
          paddingX="gutter"
          paddingY={['xlarge', 'xlarge']}
          className={starClass}
        >
          <Box paddingY={['large', 'xlarge']}>
            <Columns
              reverse={reverse}
              collapseBelow="tablet"
              space={['large', 'xxlarge']}
              alignY="center"
            >
              <Column width="1/2">
                <Box style={{ maxWidth: '460px' }}>
                  <Stack space="large">
                    <Heading level="3">{title}</Heading>
                    <>{children}</>
                  </Stack>
                </Box>
              </Column>
              <Column width="1/2">
                <Box
                  className={styles.img}
                  boxShadow="small"
                  style={{ backgroundImage: `url(${icon})` }}
                />
              </Column>
            </Columns>
          </Box>
        </Box>
      </ContentBlock>
    </Box>
  );
};

export default ProductPromos;
